export default __webpack_public_path__ + "static/media/roulette_bg.ae6ecf4e.png";